import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { TreoDateRangeComponent } from './date-range.component';
import { TsButtonModule } from 'tsui';

@NgModule({
  declarations: [TreoDateRangeComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TsButtonModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatMomentDateModule],
  exports: [TreoDateRangeComponent],
})
export class TreoDateRangeModule {}
